import { getStateWithOnlyOneLevel } from '../utils/StateSelectorHelper';

const getState = state => getStateWithOnlyOneLevel(state, 'ErrorHandler');

export const getLocalNotificationsReducer = state => getState(state).get('localNotifications');
export const getDurationReducer = state => getState(state).get('duration');
export const getTotalNotificationsReducer = state => getState(state).get('totalNotifications');
